import { textForUserOrAIEdited } from "constants/list"
import { canEditTask, localisedValue } from "utils"
import { createPrivilegeObject } from "utils/privileges/privilegesMapper"

const taskListingTransformer = data => ({
  ...data,
  rows: data?.rows?.map(item => {
    return {
      ...item,
      name: [
        item?.TaskType?.Parent?.name ? localisedValue({ object: item?.TaskType.Parent, key: "name" }) : "",
        item?.TaskType?.name ? localisedValue({ object: item?.TaskType, key: "name" }) : "",
      ],
      Project: item?.InternalInquiry?.Project,
      editedText: textForUserOrAIEdited()[item?.updatedBySource] || "",
      canEdit: canEditTask(item),
      privileges: createPrivilegeObject(item.privileges),
    }
  }),
})

export default taskListingTransformer
